import { ToursCatalogScreen } from '../(tabs)/tours/index'
import { seedToursPreview } from '../../preview/seed'
import { PreviewSeedBoundary } from '../../preview/PreviewSeedBoundary'

export default function PreviewCatalogRoute() {
  return (
    <PreviewSeedBoundary seed={seedToursPreview} seedKey="catalog">
      <ToursCatalogScreen routeBase="/preview" />
    </PreviewSeedBoundary>
  )
}
